import {
    apiRequest,
    flexList,
    flexInactive
} from "../../../../../services/adapters/kepegawaian/flexyportService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", flexList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", flexInactive, {
            body: query
        }, true)
    }
}

export default DataTableRepository